import React, { useEffect, useState } from "react";
import { Row, Col, Typography, Spin, Card } from "antd";
import axios from "axios";
import { API_URL } from "../../config";
import { DeviceIds } from "../common/helper/helper";
const { Title } = Typography;

const SummaryTab = ({ appointment_id, patientDetails }) => {
  const [summaryData, setSummaryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [ecgImageUrl, setEcgImageUrl] = useState(null);

  useEffect(() => {
    const fetchEcgSummary = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/device/ecg_summary?appointment_id=${appointment_id}`,
          {
            responseType: "blob",
          },
        );

        const imageUrl = URL.createObjectURL(response.data);
        setEcgImageUrl(imageUrl);
      } catch (error) {
        console.error("Error fetching ECG summary:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchEcgSummary();

    return () => {
      if (ecgImageUrl) {
        URL.revokeObjectURL(ecgImageUrl);
      }
    };
  }, [appointment_id, ecgImageUrl]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/device/appointment_summary/?appointment_id=${appointment_id}`,
        );
        setSummaryData(response.data || []);
        setLoading(false);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setSummaryData([]);
        } else {
          setError(error);
        }
        setLoading(false);
      }
    };

    fetchData();
  }, [appointment_id, API_URL]);

  if (loading) return <Spin />;
  if (error) return <p>Error loading data</p>;

  const getDeviceValue = (deviceId) => {
    const device = summaryData.find((item) => item.device_id === deviceId);
    return device
      ? { value: device.string_value || device.value, unit: device.units || "" }
      : { value: "-", unit: "" };
  };

  const vitalsLeft = [
    {
      label: "Blood Pressure",
      value: `${getDeviceValue(DeviceIds.BPSys).value}/${
        getDeviceValue(DeviceIds.BPDia).value
      }`,
      unit: getDeviceValue(DeviceIds.BPDia).unit,
    },
    {
      label: "Temperature",
      ...getDeviceValue(DeviceIds.Temperature),
      isHigh: parseFloat(getDeviceValue(DeviceIds.Temperature).value) > 37.5,
    },
    {
      label: "Body Fat",
      ...getDeviceValue(DeviceIds.FatPercentage),
    },
  ];

  const vitalsRight = [
    {
      label: "SPO2",
      ...getDeviceValue(DeviceIds.SPO2),
    },
    {
      label: "Weight",
      ...getDeviceValue(DeviceIds.Weight),
    },
    {
      label: "Height",
      ...getDeviceValue(DeviceIds.Height),
    },
  ];

  return (
    <React.Fragment>
      {!patientDetails?.mobile ? (
        <Card>
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Row>
                <Col span={12}>
                  <Title level={5}>Vital</Title>
                </Col>
                <Col span={12}>
                  <Title level={5}>Reading</Title>
                </Col>
              </Row>
              {vitalsLeft.map((vital) => (
                <Row key={vital.label} style={{ marginBottom: "8px" }}>
                  <Col span={12} style={{ fontWeight: "bold" }}>
                    {vital.label}
                  </Col>
                  <Col
                    span={12}
                    style={{ color: vital.isHigh ? "red" : "black" }}
                  >
                    {vital.value} {vital.unit}
                  </Col>
                </Row>
              ))}
            </Col>
            <Col span={12}>
              <Row>
                <Col span={12}>
                  <Title level={5}>Vital</Title>
                </Col>
                <Col span={12}>
                  <Title level={5}>Reading</Title>
                </Col>
              </Row>
              {vitalsRight.map((vital) => (
                <Row key={vital.label} style={{ marginBottom: "8px" }}>
                  <Col span={12} style={{ fontWeight: "bold" }}>
                    {vital.label}
                  </Col>
                  <Col span={12}>
                    {vital.value} {vital.unit}
                  </Col>
                </Row>
              ))}
            </Col>
          </Row>
        </Card>
      ) : null}
      <Card>
        <Col xs={24} md={24}>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "300px",
              }}
            >
              <Spin size="large" />
            </div>
          ) : ecgImageUrl ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "300px",
                width: "500px",
                margin: "auto",
              }}
            >
              <img
                alt="ECG Report"
                src={ecgImageUrl}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
                onError={(e) => {
                  e.target.style.display = "none";
                  console.error("Failed to load image");
                }}
              />
            </div>
          ) : (
            <div>No ECG Data Available</div>
          )}
        </Col>
      </Card>
    </React.Fragment>
  );
};

export default SummaryTab;
